// Fetch all synchronizable exchanges (CCXT + connectors) from the backend
export async function getAllExchanges() {
  const res = await fetch('/api/exchanges/synchronizable');
  if (!res.ok) throw new Error('Erreur récupération exchanges');
  return await res.json();
}

export async function getExchangeInfos(exchangeCodes) {
  const res = await fetch('/api/exchanges/exchange-info', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(exchangeCodes)
  });
  if (!res.ok) throw new Error('Erreur récupération infos exchange');
  return await res.json();
}
